export default __webpack_public_path__ + "static/media/2.5ff00b7d.jpg";